module.exports = __webpack_public_path__ + "img/5.d66172f0.jpg";